module.exports = __webpack_public_path__ + "media/images/offers-title-a0afcc48.jpeg";